module.exports = __webpack_public_path__ + "img/Paladin-draenei-m-60.66c8df92.gif";